import Condition from '@app/Trips/Condition'
import MonthlyDistribution from '@app/Trips/MonthlyDistribution'
import ContractRequest from '@app/Trips/ContractRequest'
import State from '@app/Trips/State'
import StateView from '@app/Trips/StateView'
import ProgressView from '@app/Trips/ProgressView'
import ProgressChartMini from '@app/Trips/ProgressChartMini'

export default function install(Vue, prefix = 'trip-') {
  Vue.component(`${prefix}condition`, Condition)
  Vue.component(`${prefix}monthly-distribution`, MonthlyDistribution)
  Vue.component(`${prefix}contract-request`, ContractRequest)
  Vue.component(`${prefix}state`, State)
  Vue.component(`${prefix}state-view`, StateView)
  Vue.component(`${prefix}progress-view`, ProgressView)
  Vue.component(`${prefix}progress-chart-mini`, ProgressChartMini)
}
